import { render } from "./DiscountDecisionParameters.vue?vue&type=template&id=74629b76&scoped=true"
import script from "./DiscountDecisionParameters.vue?vue&type=script&lang=js"
export * from "./DiscountDecisionParameters.vue?vue&type=script&lang=js"

import "./DiscountDecisionParameters.vue?vue&type=style&index=0&id=74629b76&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74629b76"]])

export default __exports__